module.exports = __webpack_public_path__ + "static/img/err-5.7847874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/err-5.png
// module id = blwD
// module chunks = 1